import { render, staticRenderFns } from "./LastUpdatedJbox.vue?vue&type=template&id=5c71d77a&"
import script from "./LastUpdatedJbox.vue?vue&type=script&lang=ts&"
export * from "./LastUpdatedJbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports